export default __webpack_public_path__ + "static/media/coinBIgLeft.6afca951.svg";